@if (creationMode) {
  <section class="reference-line-container">
    <div class="reference-line-create">
      <button class="btn btn--primary mr-10" [disabled]="(selectedTagsConfigured.length === 0)" (click)="openModalReferenceLine()">{{'action.createReferenceLine' | translate}}</button>
    </div>
    @if (referenceLines.length > 0) {
      <div class="reference-lines">
        <span class="title">{{'stations.graph.tag.referenceLines' | translate}}</span>
        <span class="element-count ml-10" >
          ({{ referenceLines.length + ' '}}
          {{'others.element' | translate}}{{referenceLines.length === 1 ? '' : 's'}})
        </span>
        <div class="lines-container">
          @for (refLine of referenceLines; track refLine; let index = $index) {
            <div class="refLine">
              <span class="title-refLine">{{refLine.name}}</span>
              <span class="button-refLine" (click)="removeRefLine(index)">
                <i title="Supprimer le repère" class="fa-solid fa-xmark remove-icon"></i>
              </span>
            </div>
          }
        </div>
      </div>
    }
  </section>
}
<div class="selection-tag__ctn" [ngClass]="id >= 0 ? 'selection-tag-index-' + id : null">
  <div class="tags-title">
    <span>{{'stations.graph.tag.selection' | translate}}</span>

    <div class="d-flex align-items-center w-100 justify-content-between pl-10">
      @if (groupTableConfiguration.detailComponent === 'tag' && tagList?.paging.totalItems > 0) {
        <span class="element-count">
          ({{ tagList?.paging.totalItems + ' '}}
          {{'others.element' | translate}}{{tagList?.paging.totalItems === 1 ? '' : 's'}})
        </span>
      }
      @if (groupTableConfiguration.detailComponent === 'tag-group' && tagGroupList?.paging.totalItems > 0) {
        <span class="element-count">
          ({{ tagGroupList?.paging.totalItems + ' '}}
          {{'others.element' | translate}}{{tagGroupList?.paging.totalItems === 1 ? '' : 's'}})
        </span>
      }

      <app-filters-table
        (unSelect)="unSelectedAll()"
        (eventEmitter)="eventReceiver($event)"
        [displayUnselect]="displayallUnselect"
        [config]="filtersConfig"
        [defaultGroup]="defaultGroup"
        [hidefilterAll]="hidefilterAll">
      </app-filters-table>
    </div>

  </div>

  @if (loadingState | async; as state) {
    @if (state === actionState.READY) {
      <!-- LIST -->
      <div class="table-container">
        @if (isoldTableView) {
          <app-tinea-table [tableColumns]=groupTableHeaders
            [tableData]="tagGroupList" [selectedTagsByDefault]=selectedTagsByDefault
            [tableConfiguration]=groupTableConfiguration (pageNumber)="checkPage($event)"
            [columnsToNotDisplay]="columnsToNotDisplay"
            (paginating)="onPagination($event)" [data]="dataForChildComponent" [isLoadingItems]="false" (eventOnClick)="onEventOnClick($event)">
          </app-tinea-table>
        }
        @if (!isoldTableView) {
          <div class="ui-table" [tableInput]='table'
          (eventOnClick)="onEventOnClick($event)"></div>
        }
      </div>
      <!-- PAGING -->
      @if (!isoldTableView) {
        <div class="ui-paging" [pagingInput]="paging"
          (eventOnClickPrevLink)="eventOnClickPrevLink($event)"
          (eventOnClickNextLink)="eventOnClickNextLink($event)">
        </div>
      }
    }
    @if (state === actionState.LOADING) {
      <span class="ui-loading" [model]="{isLoading: true}"></span>
    }
  }

</div>